export type RuntimeMode = "web" | "native" | "auto";

export const getRuntimeMode = (): RuntimeMode => {
  const raw = (import.meta.env.VITE_RUNTIME ?? "").toString().trim().toLowerCase();
  if (raw === "web") return "web";
  if (raw === "native") return "native";
  return "auto";
};
